<template>
    <div :class="['message', message.role]">
      <div class="avatar">
        {{ message.role === 'assistant' ? 'F' : 'Vous' }}
      </div>    
      <div class="bubble">
        <div class="markdown"  v-html="renderedContent" </div>    
      </div>
    </div>
</template>
<script>    
    import {marked} from "marked";
    export default {
      props:{
        message:Object    
      },
    computed:{
        renderedContent(){
            return marked.parse(this.message.content);
        }
    }
}
</script>
    
<style scoped>
@keyframes appear{
    from{
        opacity:0;
        transform:translateY(12px);
    }

    to{
        opacity:1;
        transform:none;
    }
}

.message{

display:flex;

gap:22px;

margin-bottom:24px;

animation:appear .35s ease;

}

.avatar{

    width:32px;
    height:32px;
    border-radius:8px;
    font-size:14px;


background:#7f1d1d;

color:white;

display:flex;

justify-content:center;

align-items:center;

font-weight:600;

flex-shrink:0;

}

.user .avatar{

background:#2d2d2d;

}

.bubble{

flex:1;

}

.markdown{

color:#ececec;

line-height:1.55;

text-align:justify;

font-size:15px;

}
    
    .markdown :deep(h1),
    .markdown :deep(h2),
    .markdown :deep(h3){
      color:white;
      margin-top:30px;
    }
    
    .markdown :deep(p){
      margin-bottom:18px;
    }
    
    .markdown :deep(li){
      margin-bottom:8px;
    }
    
    .markdown :deep(code){
      background:#2e2e2e;
      padding:3px 6px;
      border-radius:5px;
    }
</style>